import {getSlotContent, getSlotTitle, standardColoring} from "../utils/plasmid";
import {Selector, sizeToValue} from "../mixins/dictionaries";
import {linearPreviewHeight} from '../mixins/constants'
import {renderVirtualPopper} from "../utils/virtualPopper";

import {select} from "d3-selection";

const d3 = {select};

export default class CartoonLinearMap {
    constructor(mediator) {
        this.mediator = mediator;
        this.initDataContainer();
        this.setPlacements();
        this.initPreview();
    }

    initDataContainer() {
        let $activeContainer = document.querySelector(`#previewTabContent .active`);
        if (!$activeContainer) {
            $activeContainer = document.querySelector(Selector.CARTOON_LINEAR_MAP)
        }
        this.$activeBoxContainer = $activeContainer.getBoundingClientRect();

        this.rangeBases = {
            "start": 0,
            "end": 0,
            "length": 0
        }
        this.currentSlot = -1;
        this.zoom = .65;

        this.step = 10 * this.zoom;
        this.arrowOffset = 12 * this.zoom;
        this.slotHeight = 60 * this.zoom;

        this.sourceObject = "sequence";
    }

    initData(decodedStructuredData, sourceData) {
        this.slots = sourceData.slots;
        this.sequenceMapped = decodedStructuredData["decodedCartoonMap"];
        this.crossMap = decodedStructuredData["decodedCrossMap"]

        this.characters = this.sequenceMapped.filter(item => !item.bond);

        this.sequenceLength = this.characters.length;
        this.fontBoxWidth = this.$activeBoxContainer.width / this.sequenceLength;
    }

    initPreview() {
        this.mainBoxContainer = d3.select(Selector.CARTOON_LINEAR_MAP)
            .append("div")
            .attr("class", "slices overflow-hidden")
            .append("svg")
            .style("height", `${linearPreviewHeight}px`)
            .style("width", "100%")

        this.rulerContainer = this.mainBoxContainer.append("g")
            .attr("transform", `translate(0,${this.placements.editor.main})`);

        this.slotsContainer = this.mainBoxContainer.append("g")
            .attr("transform", `translate(0,${this.placements.editor.main})`);
    }

    setPlacements() {
        this.placements = {
            editor: {
                main: linearPreviewHeight / 2,
                ruler: 0
            }
        }
    }

    setData(decodedStructuredData, sourceData) {
        this.initData(decodedStructuredData, sourceData);
        this.render();
    }

    render() {
        this.drawRuler();
        this.drawSlots();
        this.enableTooltip();
    }

    drawRuler() {
        this.rulerContainer.selectAll(".lines").remove();
        this.rulerContainer.append("g")
            .attr("class", "lines")
            .append("path")
            .attr("class", this.slots.length === 0 ? 'stroke-primary-light' : 'ruler')
            .attr("d", `M0,0 L${this.$activeBoxContainer.width},0`)
            .style("fill", "none")
            .style("stroke-width", 5 * this.zoom)
            .attr("opacity", 1);
    }

    drawSlots() {
        let start = 0;
        let end = this.step;
        this.slotsContainer.selectAll(".slice-labels").remove();

        this.slots.forEach(s => {
            this.drawSlot(s, end, start);
            end += this.slotWidth(s.size) + this.step;
            start += s.length
        });

        this.slotsContainer
            .attr("transform", `translate(${(this.$activeBoxContainer.width - end) / 2},${(linearPreviewHeight - this.slotHeight) / 2})`);
    }

    slotWidth(size) {
        const initWith = 25 * this.zoom;
        return sizeToValue[size] * initWith;
    }

    drawSlot(slot, end, start) {
        const self = this;
        let left = 0;
        let arrowLeft = 0;
        let right = this.slotWidth(slot.size);
        let arrowRight = this.slotWidth(slot.size);

        let areaShape = this.slotsContainer.append("g")
            .attr("class", "slice-labels")
            .attr("transform", `translate(${end}, 0)`);

        if (slot.shape === "arrow" && slot.direction) {
            if (slot.direction === 1) {
                right -= this.arrowOffset
            } else {
                left += this.arrowOffset
            }
        }

        let popperContent = getSlotContent(slot, true);
        let popperTitle = getSlotTitle(slot);

        areaShape
            .append("line")
            .attr("x1", 0).attr("y1", 0)
            .attr("x2", arrowRight).attr("y2", 0)
            .attr("stroke-width", "5");

        areaShape
            .append("path")
            .attr("data-toggle", "virtual-popper")
            .attr("data-virtual-popper-title", popperTitle)
            .attr("data-virtual-popper-content", popperContent)
            .attr("d", `M${left},0
                L${right},0
                L${arrowRight},${this.slotHeight / 2}
                L${right},${this.slotHeight}
                L${left},${this.slotHeight}
                L${arrowLeft},${this.slotHeight / 2}
                Z`)
            .attr("class", () => {
                return standardColoring(slot, undefined, false);
            })
            .on("click", (e) => {
                e.preventDefault();
                const firstEncoded = slot.dna_sequence.encodings[0];
                const start = self.crossMap.find( item => item.pk === firstEncoded.id).sequence.start;

                this.EventsTrigger("setOffsetScroll", {
                    "start": start + 1,
                    "end": start + 1,
                    "source": this.sourceObject
                });

                this.EventsTrigger("slide", "end");
                this.EventsTrigger("updateRender");

                if (slot.length) {
                    this.EventsTrigger("selectRange", {
                        "start": start + 1,
                        "end": start + 2,
                        "source": this.sourceObject
                    });

                } else {
                    this.EventsTrigger("selectRange", {
                        "start": start + 1,
                        "end": start + 1,
                        "source": this.sourceObject
                    });
                }
            })
    }

    enableTooltip() {
        const elements = document.querySelectorAll('[data-toggle="virtual-popper"]')
        renderVirtualPopper(elements);
    }

    EventsTrigger(action, data) {
        if (this.mediator) {
            this.mediator.trigger(action, data, this)
        }
    }

    EventsOn() {
        if (this.mediator) {
            this.mediator.on("setData", "setData", this);
        }
    }
}